import { CardHeader, Card, CardBody } from "reactstrap";
//import {  } from "@material-ui/core";
import styled from "styled-components";

export const StyledCard = styled(Card)`
    border: 1px solid rgba(0, 0, 0, 0.125);
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    border-radius: 0px;
    margin: 0px;
    && {
        margin: 0px;
        overflow: visible;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
        border-radius: 0px;
    }
`;
export const StyledContent = styled(CardBody)`
    padding: 24px;
`;
export const StyledHeader = styled(CardHeader)``;
export const StyledViewContainer = styled.div`
    padding-top: 10px;
`;
